import React from 'react'
import Link from 'gatsby-link'
import MenuComponent from '../../components/burger-menu';
import LogoComponent from '../../components/logo';
import HeaderNav from '../../components/header-nav';

export default class MainHeader extends React.Component {
  reloadPage() {
    typeof window !== 'undefined' && ( window.location.href = '/')
  }
  render() {
    return (
      <div className="header--basic">
        <span className="header-logo" onClick={this.reloadPage}>
          <LogoComponent class="logo--l"></LogoComponent>
        </span>
        <h2 className="header-title">
          7<sup>th</sup> PZAF / PALERMO
            <span className="header-subtitle">27<sup>th</sup> - 29<sup>th</sup> June 2018</span>
        </h2>
        {/* <HeaderNav class="header-nav" /> */}
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/headers/main-header.js